import React, { useContext } from "react";
import { Link, navigate } from "gatsby";
import { LoginPopupContext } from "../../../templates/article";
import AuthContext from "../../../services/firebase/auth-context/provider";
var SubscriptionRequestSpotlight = function SubscriptionRequestSpotlight(_ref) {
    var loadFullArticle = _ref.loadFullArticle, _ref$type = _ref.type, type = _ref$type === void 0 ? "plus" : _ref$type, _ref$nonPlusSubscribe = _ref.nonPlusSubscriber, nonPlusSubscriber = _ref$nonPlusSubscribe === void 0 ? false : _ref$nonPlusSubscribe, _ref$customerId = _ref.customerId, customerId = _ref$customerId === void 0 ? "" : _ref$customerId;
    var authenticated = useContext(AuthContext)[0].authenticated;
    var LoginContext = useContext(LoginPopupContext);
    var smallTitle = "Nur für Abo+";
    var coloringBox = "border-makroGreen bg-makroGreenLight";
    var coloringSmallTitle = "bg-makroGreen";
    var coloringButton = "border-makroGreen bg-makroGreen hover:text-makroGreen";
    var loadArticle = /*#__PURE__*/ React.createElement(React.Fragment, null);
    if (type == "paywall") {
        smallTitle = "Für alle Abonnenten";
        coloringBox = "border-makroRedPortuguese bg-makroRustyLight";
        coloringSmallTitle = "bg-makroRedPortuguese";
        coloringButton = "border-makroRedPortuguese bg-makroRedPortuguese hover:text-makroRedPortuguese";
    }
    else if (type == "free") {
        smallTitle = "Kostenloser Artikel";
        coloringBox = "border-makroRedPortuguese bg-makroRustyLight";
        coloringSmallTitle = "bg-makroRedPortuguese";
        coloringButton = "border-makroRedPortuguese bg-makroRedPortuguese hover:text-makroRedPortuguese";
        loadArticle = /*#__PURE__*/ React.createElement("button", {
            onClick: loadFullArticle,
            className: "w-full text-lg text-white mt-3 px-2 pt-2 pb-1 border-2 border-solid border-gray-600 bg-gray-600 hover:text-gray-600 hover:bg-transparent"
        }, "GANZEN ARTIKEL LESEN");
    }
    var subscriptionButton = /*#__PURE__*/ React.createElement(Link, {
        to: type == "plus" ? "/abonnieren/plus" : "/abonnieren/",
        className: "w-full inline-block text-lg text-center text-white mt-8 px-2 pt-2 pb-1 border-2 border-solid " + coloringButton + " hover:bg-transparent hover:bg-transparent-important"
    }, type == "plus" ? "ABO+ zeichnen" : "ABONNIEREN SIE MAKROSKOP");
    if (nonPlusSubscriber) {
        subscriptionButton = /*#__PURE__*/ React.createElement("a", {
            href: "mailto:aboservice@makroskop.eu?subject=Zu%20Abo%2B%20aufwerten&body=Bitte%20werten%20Sie%20mein%20Abonnement%20zu%20einem%20ABO%2B%20auf.%20Kunden-ID%3A%20" + customerId,
            className: "w-full inline-block text-lg text-center text-white mt-8 px-2 pt-2 pb-1 border-2 border-solid " + coloringButton + " hover:bg-transparent hover:bg-transparent-important"
        }, "Zu ABO+ aufwerten");
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "shadow border-t-8 border-solid " + coloringBox + " mt-8 px-4 py-6"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-4xl",
        style: {
            fontSize: "2.6em"
        }
    }, "Es werde Licht!"), /*#__PURE__*/ React.createElement("div", {
        className: "inline-block font-bold text-lg text-white " + coloringSmallTitle + " px-4 py-1 my-4 -ml-4"
    }, smallTitle), /*#__PURE__*/ React.createElement("div", {
        className: "text-gray-800 col-span-2",
        style: {
            columnCount: 2
        }
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-2"
    }, "Das MAKROSKOP Spotlight ist unser exklusiver Scheinwerfer auf einen Schwerpunkt, den wir alle zwei Wochen f\xFCr unsere ABO+ Leser neu ausrichten."), /*#__PURE__*/ React.createElement("p", {
        className: "mb-2"
    }, "Warum versteht fast niemand unser eigenes Geldsystem? Macht Arbeitszeitverk\xFCrzung Sinn? Wie geht es mit der Globalisierung weiter? Mit ausgew\xE4hlten Texten stellen wir uns gro\xDFen Fragen aus verschiedenen Perspektiven \u2013 kontrovers, tiefgr\xFCndig und ausf\xFChrlich. Eine sinnstiftende Lekt\xFCre f\xFCr Ihre Samstage und Sonntage."), /*#__PURE__*/ React.createElement("p", {
        className: "mb-2"
    }, "Sie haben noch kein Abo+? Dann werten Sie jetzt auf und profitieren von einem erweiterten inhaltlichen Angebot und anderen Vorteilen mehr."), subscriptionButton, loadArticle, /*#__PURE__*/ React.createElement("div", {
        className: "mt-3"
    }, type == "plus" ? "Sie haben ein Abo+?" : "Schon Abonnent?", " Dann hier", " ", /*#__PURE__*/ React.createElement("span", {
        className: "font-bold underline hover:no-underline cursor-pointer",
        onClick: !authenticated ? LoginContext.onLoginClick : function () {
            return navigate("/anmelden/");
        }
    }, "einloggen"), "!")));
};
export default SubscriptionRequestSpotlight;
